'use client';

import { useEffect } from 'react';

export default function CrashClient() {
  useEffect(() => {
    throw new Error('This is a client-side error from crashclient');
  }, []);

  return (
    <main>
      <h1>This page will crash on the client.</h1>
    </main>
  );
}
